import script from "./navigation-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./navigation-bar.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=074d5bd3&scoped=true&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-074d5bd3"]])

export default __exports__